<script setup>

// eslint-disable-next-line no-unused-vars
const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    id: {
        type: String,
        default: `radio-input-${Math.random()}`,
    },
    model: {
        type: Object,
        default: () => {
        },
    },
    value: {
        type: String,
        required: true,
    },
    modelValue: {
        type: String,
        default: "",
    },
    dataTest: {
        type: String,
        default: "",
    },
    selected: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(["update:modelValue"]);

const updateValue = (event) => {
    emit("update:modelValue", event.target.value);
};

</script>

<template>
    <input
        data-test-id="radio-btn"
        :data-test="`${props.dataTest}-input`"
        :name="props.name"
        :id="props.id"
        :value="props.value"
        :disabled="props.disabled"
        @input="updateValue"
        type="radio"
        v-bind="{checked: props.selected}"
    />
    <label v-bind:class="{ 'text-disabled': props.disabled && !props.selected}" :for="id"
           data-test-id="radio-lbl"
           :data-test="`${props.dataTest}-label`">
        <slot></slot>
    </label>
</template>

<style scoped>
/** CSS RESET */
input {
    background: transparent;
    border: none;
    box-sizing: border-box;
    border-radius: initial;
    padding: initial;
}

label:not(.checkbox) {
    visibility: initial;
    opacity: initial;
    font-weight: initial;
    transition: none;
}

/** END OF CSS RESET */

[type="radio"]:checked,
[type="radio"]:not(:checked) {
    position: absolute;
    left: -99999px;
}

[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
}

[type="radio"]:checked + label:before,
[type="radio"]:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 1px solid #260045;
    border-radius: 100%;
    background: #fff;
}

[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
    content: '';
    width: 10px;
    height: 10px;
    background: #260045;
    position: absolute;
    top: 4px;
    left: 4px;
    border-radius: 100%;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
}

[type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
}

[type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
}
/* Disabled style */
[type="radio"]:disabled:not(:checked) {
    opacity: .3!important;
}
.text-disabled {
    opacity: .3!important;
}
</style>
